import { render, staticRenderFns } from "./AddMainContent.vue?vue&type=template&id=f2b8372e"
import script from "./AddMainContent.vue?vue&type=script&lang=js"
export * from "./AddMainContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports